import router from "src/routes/routes";
import { CommonAPIService } from "./commonHandler";

const api = new CommonAPIService(router);
const BASE = "/api/quarterlyReports";

export const quarterlyReportsService = {
  generateQuarterlyReport: (data) => api.postCall(BASE, data),
  uploadQuarterlyReport: (formData) => api.postFormDataCall(`${BASE}/upload`, formData),
  getQuarterlyReport: (id) => api.getCall(`${BASE}/${id}`),
  getQuarterlyReportsForClient: (clientId) => api.getCall(`${BASE}/client/${clientId}`),
  getClientServiceCodes: (clientId, params) =>
    api.getCall(`${BASE}/client/${clientId}/service-codes`, params),
  updateQuarterlyReport: (id, data) => api.putCall(`${BASE}/${id}`, data),
  deleteQuarterlyReport: (id) => api.deleteCall(`${BASE}/${id}`),
  downloadQuarterlyReportPdf: (id) => api.getBlobCall(`${BASE}/${id}/pdf`),
  emailQuarterlyReport: (id, data) => api.postCall(`${BASE}/${id}/email`, data),
};
